import { render, staticRenderFns } from "./MarkedJournals.vue?vue&type=template&id=091be199&"
import script from "./MarkedJournals.vue?vue&type=script&lang=js&"
export * from "./MarkedJournals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports